<template>
    <div>
      <v-layout class="mainfont" wrap justify-center pb-7>
        <v-flex xs11 pt-4>
          <v-layout wrap justify-center>
            <v-snackbar v-model="showSnackBar" color="black">
              <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">
                  <span style="color: white">
                    {{ msg }}
                  </span>
                </v-flex>
                <v-flex text-right>
                  <v-btn small :ripple="false" text @click="showSnackBar = false">
                    <v-icon style="color: white">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-snackbar>
            <vue-element-loading
              :active="appLoading"
              :is-full-screen="true"
              background-color="#FFFFFF"
              color="#42275a"
              spinner="spinner"
            />
            <v-flex xs12>
              <v-card class="pb-4">
                <v-layout wrap justify-start>
                  <v-flex xs12 pl-3 pt-3 pb-4 class="bgcustom">
                    <span style="font-size: 25px; color: white"
                      >Application Number - {{ list.applicationNo }}</span
                    >
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap pb-3>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg12 px-5>
                    <v-layout wrap justify-center>
                  
                  <v-flex xs5 lg3 text-left>
                    <span class="subheading" style="font-size: 16px;">
                      Applicant Name
                    </span>
                    <br />
                    <span>{{ list.applicantName }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left>
                    <span class="subheading" style="font-size: 16px;">
                      District
                    </span>
                    <br />
                    <span>{{ list.applicantDistrict }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left>
                    <span class="subheading" style="font-size: 16px;">
                      Email
  
                    </span>
                    <br />
                    <span>{{ list.applicantEmail }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left>
                    <span class="subheading" style="font-size: 16px;">
                      Mobile Number
  
                    </span>
                    <br />
                    <span>{{ list.applicantMobileNo }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Address 1
  
                    </span>
                    <br />
                    <span>{{ list.applicantAddress1 }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Address 2
  
                    </span>
                    <br />
                    <span>{{ list.applicantAddress2 }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Pincode
  
                    </span>
                    <br />
                    <span>{{ list.applicantPinCode }}</span>
                  </v-flex>
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Id Type
                    </span>
                    <br />
                    <span>{{ list.idType }}</span>
                  </v-flex>
                  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Depot Name
  
                    </span>
                    <br />
                    <span>{{ list.depotName }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Depot Address
  
                    </span>
                    <br />
                    <span>{{ list.depotAddress }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Timber Qantity
  
                    </span>
                    <br />
                    <span>{{ list.timberQuantity }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Id Type
                    </span>
                    <br />
                    <span>{{ list.idType }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Id Card No
                    </span>
                    <br />
                    <span>{{ list.idcardNo }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px;">
                      Need Passbook 
  
                    </span>
                    <br />
                    <span>{{ list.needPassBook? "Yes": "No" }}</span>
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px">
                      Id Proof</span>
                      <br />
  
                    <v-btn small class="bgcustom" dark  :href="mediaURL + list.identityCard" target="_blank"><span
                        style="
                          text-transform: none;
                          font-family: mainfont;
                          font-size: 12px;
                        ">View
                      </span></v-btn>
                    <br />
                  </v-flex>
  
                  <v-flex xs5 lg3 text-left pt-4>
                    <span class="subheading" style="font-size: 16px">
                      ownershipCertificate </span>
                      <br />
  
                    <v-btn small class="bgcustom" dark  :href="mediaURL + list.ownershipCertificate" target="_blank"><span
                        style="
                          text-transform: none;
                          font-family: mainfont;
                          font-size: 12px;
                        ">View
                      </span></v-btn>
                    <br />
                  </v-flex>
  
                  <v-flex xs12 lg3 text-left pt-4>
    <span class="subheading" style="font-size: 16px">Property Mark Impressions</span>
    <br />
  
    <!-- Loop through each property mark impression -->
    <v-flex xs12 lg3 pt-3 pl-3>
      <v-layout row wrap>
        <v-flex v-for="(impression, index) in list.propertyMarkImpressions" :key="index" xs12 lg12 pb-2>
          <v-btn small class="bgcustom" dark :href="mediaURL + impression" target="_blank">
            <span style="text-transform: none; font-family: mainfont; font-size: 12px;">Impression {{ index + 1 }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <br />
  </v-flex>

  <v-flex xs12 lg9 text-left pt-4>
  <span class="subheading" style="font-size: 16px">Progress</span>
  <br />

  <!-- Loop through each property mark impression -->
  <v-flex xs12 lg4 pt-3 pl-3>
    <v-layout row wrap>
      <v-flex xs6 lg4>
        <v-btn small class="bgcustom" dark @click="$router.push('/records?id=' + id)">
          <span style="text-transform: none; font-family: mainfont; font-size: 12px;">Progress</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <br />
</v-flex>
  
  <v-flex lg3 class="text-start">
    </v-flex>
  
    <v-flex lg3 class="text-start">
      </v-flex>
      <v-flex lg3 class="text-start">
        </v-flex>
                </v-layout>
              </v-flex>       
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
         
  
           <v-layout wrap justify-center>
    <v-flex lg12 pt-5>
      <!-- <v-card>
        <v-layout wrap justify-start>
          <v-flex xs12 pl-3 pt-3 pb-4 class="bgcustom">
            <span style="font-size: 25px; color: white">Reasons for Refusal with Range Suggestions</span>
          </v-flex>
  
          <v-flex lg12 pa-4>
    <v-container fluid>
      <v-row>
        <v-layout wrap justify-center>
         
        </v-layout>

       
        <v-flex lg12 pt-6>
          <v-layout wrap justify-end>
            <v-flex lg4 class="text-end">
              <v-layout wrap justify-end>
                <v-flex lg5 class="text-end">
                  <v-btn color="success" @click="refusalreasonSubmit()">Save</v-btn>
                </v-flex>
                <v-flex lg5 v-if="forwardbtn" class="text-end">
                  <v-btn color="success" @click="submitRFOTsevenReason(), (forwarddialog = true)">Forward</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-row>
    </v-container>
  </v-flex>
        </v-layout>
      </v-card> -->

      

      

      <v-layout wrap justify-center pt-4>
        <v-flex lg12>
            <v-card>
                <v-layout wrap justify-center>
                    <v-flex xs12 pl-3 pt-3 pb-4 class="bgcustom">
                        <span style="font-size: 25px; color: white">Final Decision</span>
                    </v-flex>

                    <v-flex lg12 pt-2 px-3>
                      <v-layout wrap justify-start>
                        <v-flex lg12>
                          <span>Final Decision</span>
                        </v-flex>
                        <v-flex lg4 pt-1>
                          <v-select
                          v-model="finalDecision"
                          :items="finalDecisionItems"
                          outlined
                          dense
                          hide-details="auto"
                          >

                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex lg12 pt-2 px-3 v-if="finalDecision !== 'Refuse'">
                      <v-layout wrap justify-start>
                        <v-flex lg12>
                          <span>Property Mark Number</span>
                        </v-flex>
                        <v-flex lg4 pt-1>
                          <v-text-field
                          v-model="propertyMarkNumber"
                          outlined
                          dense
                          hide-details="auto"
                          >

                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                </v-layout>

                <v-layout wrap justify-center py-3 px-3 class="fill-height">
                

                    <!-- <v-flex xs12 lg4 pt-2 align-center>
                        <span>Upload RFO Inspection Report.
                        <span style="color: rgb(255, 0, 0)">*</span>
                        </span>
                                        
                    </v-flex>
                    <v-flex lg8 pt-2>
                      <input type="file" id="inspectionReport" ref="inspectionReport" accept=".pdf, .jpeg, .png"
                      @change="handleFileChange('inspectionReport')" />
                    </v-flex>

                    <v-flex xs12 lg4 align-center>
                      <span>Photos.
                      <span style="color: rgb(255, 0, 0)">*</span>
                      </span>
                                        
                    </v-flex>
                    <v-flex lg8 pt-1>
                      <input type="file" id="rfoPhotos" ref="rfoPhotos" accept=".pdf, .jpeg, .png"
                      @change="handleFileChange('rfoPhotos')" />
                    </v-flex> -->

                    <v-flex lg12>
          <v-layout wrap justify-center>
            <v-flex lg12 pb-1>
              <span>Final Remarks</span>
            </v-flex>
          </v-layout>
          <v-textarea 
            v-model="remarks" 
            outlined 
            dense 
            rows="2"
            hide-details="auto"
          ></v-textarea>
        </v-flex>

        <v-flex lg12 pt-4 class="text-end" v-if="finalDecision !== 'Refuse'">
  <v-btn :loading="isLoading" color="success" @click="submitFinalDecision()" :disabled="isLoading">
    <span v-if="!isLoading">Submit</span>
    <span v-else>Loading...</span>
  </v-btn>
</v-flex>
 

  <v-flex lg12 pt-4 class="text-end" v-if="finalDecision === 'Refuse' " >
    <v-btn :loading="isLoading" style="background-color: black;" @click="submitFinalRefusal()" :disabled="isLoading">
      <span v-if="!isLoading"><span style="color: white;" >Refusal</span></span>
      <span v-else>Loading...</span>
    </v-btn>
  </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-center>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434">
                      <span style="font-size: 25px; color: white">Comments by Ministerial Head (after field verification)</span>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap justify-center py-3 px-3 class="fill-height">
                    <!-- <v-flex lg12 pb-1>
                    <span>GPS Readings (in Degrees )</span>
                  </v-flex>

                  <v-flex lg12>
                    <v-layout wrap justify-start>
                      <v-flex lg2>
                        <v-text-field
                        v-model="list.latitude"
                        outlined
                        type="number"
                        dense
                        readonly
                        placeholder="Latitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg2 pl-2>
                        <v-text-field
                        v-model="list.longitude"
                        type="number"
                        outlined
                        readonly  
                        dense
                        placeholder="Longitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Is same Impression?</span>
    </v-flex>
    <v-flex lg4>
      <v-radio-group v-model="list.isSameImpression" row readonly hide-details="auto">
  <v-radio label="Yes" :value="true"></v-radio>
  <v-radio label="No" :value="false"></v-radio>
</v-radio-group>
</v-flex>
  </v-layout>
</v-flex>

<v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Distance from the Forest (in KM)</span>
    </v-flex>
    <v-flex lg2 pt-1>
      <v-text-field
      v-model="list.distance"
      placeholder="Distance in KM"
      outlined
      readonly
      dense
      hide-details="auto"
      >

      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex> -->

                    <v-flex lg12>
                      <v-layout wrap justify-start>
                        <v-flex lg12>
                          <span style="font-weight: 600;">Ministerial Head remarks</span>
                        </v-flex>
                        <v-flex lg12 pt-1>
                          <span>{{list.ministerialHeadRemarks}}</span>
                          <!-- <v-textarea v-model="list.rforemarks" placeholder="Distance in KM" outlined readonly rows="3"
                            dense hide-details="auto">

                          </v-textarea> -->
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

      <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-center>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434">
                      <span style="font-size: 25px; color: white">Comments by Clerk (after field verification)</span>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap justify-center py-3 px-3 class="fill-height">
                    <!-- <v-flex lg12 pb-1>
                    <span>GPS Readings (in Degrees )</span>
                  </v-flex>

                  <v-flex lg12>
                    <v-layout wrap justify-start>
                      <v-flex lg2>
                        <v-text-field
                        v-model="list.latitude"
                        outlined
                        type="number"
                        dense
                        readonly
                        placeholder="Latitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg2 pl-2>
                        <v-text-field
                        v-model="list.longitude"
                        type="number"
                        outlined
                        readonly  
                        dense
                        placeholder="Longitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Is same Impression?</span>
    </v-flex>
    <v-flex lg4>
      <v-radio-group v-model="list.isSameImpression" row readonly hide-details="auto">
  <v-radio label="Yes" :value="true"></v-radio>
  <v-radio label="No" :value="false"></v-radio>
</v-radio-group>
</v-flex>
  </v-layout>
</v-flex>

<v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Distance from the Forest (in KM)</span>
    </v-flex>
    <v-flex lg2 pt-1>
      <v-text-field
      v-model="list.distance"
      placeholder="Distance in KM"
      outlined
      readonly
      dense
      hide-details="auto"
      >

      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex> -->

                    <v-flex lg12>
                      <v-layout wrap justify-start>
                        <v-flex lg12>
                          <span style="font-weight: 600;">Clerk remarks</span>
                        </v-flex>
                        <v-flex lg12 pt-1>
                          <span>{{list.sectionClerkRemarks}}</span>
                          <!-- <v-textarea v-model="list.rforemarks" placeholder="Distance in KM" outlined readonly rows="3"
                            dense hide-details="auto">

                          </v-textarea> -->
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-center>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434">
                      <span style="font-size: 25px; color: white">Comments by RFO (after field verification)</span>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap justify-center py-3 px-3 class="fill-height">
                    <!-- <v-flex lg12 pb-1>
                    <span>GPS Readings (in Degrees )</span>
                  </v-flex>

                  <v-flex lg12>
                    <v-layout wrap justify-start>
                      <v-flex lg2>
                        <v-text-field
                        v-model="list.latitude"
                        outlined
                        type="number"
                        dense
                        readonly
                        placeholder="Latitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg2 pl-2>
                        <v-text-field
                        v-model="list.longitude"
                        type="number"
                        outlined
                        readonly  
                        dense
                        placeholder="Longitude"
                        hide-details="auto"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Is same Impression?</span>
    </v-flex>
    <v-flex lg4>
      <v-radio-group v-model="list.isSameImpression" row readonly hide-details="auto">
  <v-radio label="Yes" :value="true"></v-radio>
  <v-radio label="No" :value="false"></v-radio>
</v-radio-group>
</v-flex>
  </v-layout>
</v-flex>

<v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Distance from the Forest (in KM)</span>
    </v-flex>
    <v-flex lg2 pt-1>
      <v-text-field
      v-model="list.distance"
      placeholder="Distance in KM"
      outlined
      readonly
      dense
      hide-details="auto"
      >

      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex> -->

                    <v-flex lg6>
                      <v-layout wrap justify-start>
                        <v-flex lg12>
                          <span style="font-weight: 600;">RFO remarks</span>
                        </v-flex>
                        <v-flex lg12 pt-1>
                          <span>{{ list.rforemarks }}</span>
                          <!-- <v-textarea v-model="list.rforemarks" placeholder="Distance in KM" outlined readonly rows="3"
                            dense hide-details="auto">

                          </v-textarea> -->
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex lg6>

<v-layout wrap justify-center  pl-3 class="fill-height">
  <v-flex lg6>
    <v-layout wrap justify-center>


      <v-flex lg12 pb-1>
        <span>Verification Report :</span> <br>
        <v-btn small dark class="bgcustom"><a target="_blank"
            :href="mediaURL + list.verificationReport">

            <span style="
    text-transform: none;
    font-family: mainfont;
    font-size: 12px;
    color: white
  ">View
            </span></a></v-btn>
      </v-flex>

    </v-layout>
  </v-flex>

  <v-flex lg6>
    <v-layout wrap justify-center>


      <v-flex lg12 pb-3>
<span>Photos :</span> <br>
<v-layout row wrap>
<v-flex
v-for="(photo, index) in list.photos"
:key="index"
lg12
class="pt-3 pl-3"
>
<v-btn small dark class="bgcustom">
<a
target="_blank"
:href="mediaURL + photo"
style="text-decoration: none"
>
<span
style="
text-transform: none;
font-family: mainfont;
font-size: 12px;
color: white;
"
>
View Photo {{ index + 1 }}
</span>
</a>
</v-btn>
</v-flex>
</v-layout>
</v-flex>


    </v-layout>
  </v-flex>

  <!-- <v-flex lg12 pb-1>
<v-btn small dark  :href="mediaURL + list.userId.verificationReport" target="_blank"><span
  style="
    text-transform: none;
    font-family: mainfont;
    font-size: 12px;
  ">View
</span></v-btn>
</v-flex> -->



</v-layout>

</v-flex>

                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-center>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434">
                      <span style="font-size: 25px; color: white">Comments by SFO</span>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap justify-center>
                    <v-flex lg6>

                      <v-layout wrap justify-center py-3 pb-4 pl-3 class="fill-height">
                        <v-flex lg12 pb-1>
                          <span style="font-weight: 600;">GPS Readings (in Degrees )</span>
                        </v-flex>

                        <v-flex lg12>
                          <v-layout wrap justify-start>
                            <v-flex lg2>
                              <v-layout wrap justify-center>
                                <v-flex lg11>
                                  <span>Latitude</span>
                                </v-flex>
                                <v-flex lg1>
                                  <span>:</span>
                                </v-flex>
                              </v-layout>
                              <!-- <v-text-field v-model="list.latitude" outlined type="number" dense readonly
                                label="Latitude" placeholder="Latitude" hide-details="auto"></v-text-field> -->
                            </v-flex>
                            <v-flex lg10 pl-2>
                              <span>{{ list.latitude }}°</span>
                            </v-flex>

                            <v-flex lg2 pt-2>
                              <v-layout wrap justify-center>
                                <v-flex lg11>
                                  <span>Longitude</span>
                                </v-flex>
                                <v-flex lg1>
                                  <span>:</span>
                                </v-flex>
                              </v-layout>

                              <!-- <v-text-field v-model="list.latitude" outlined type="number" dense readonly
                                label="Latitude" placeholder="Latitude" hide-details="auto"></v-text-field> -->
                            </v-flex>
                            <v-flex lg10 pt-2 pl-2>
                              <span>{{ list.longitude }}°</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <!-- <v-flex lg12 pt-2>
  <v-layout wrap justify-start>
    <v-flex lg12>
      <span>Is same Impression?</span>
    </v-flex>
    <v-flex lg4>
      <v-radio-group v-model="list.isSameImpression" row readonly hide-details="auto">
  <v-radio label="Yes" :value="true"></v-radio>
  <v-radio label="No" :value="false"></v-radio>
</v-radio-group>
</v-flex>
  </v-layout>
</v-flex> -->

                        <v-flex lg12 pt-2>
                          <v-layout wrap justify-start>
                            <v-flex lg12>
                              <span style="font-weight: 600;">Distance from the Forest (in KM)</span>
                            </v-flex>
                            <v-flex lg8 pt-1>
                              <span>{{ list.distance }} KM</span>
                              <!-- <v-text-field v-model="list.distance" placeholder="Distance in KM" outlined readonly dense
                                hide-details="auto">
                              </v-text-field> -->
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-layout>

                    </v-flex>

                    <v-flex lg6>

                      <v-layout wrap justify-center py-3 pb-4 pl-3 class="fill-height">
                        <v-flex lg6>
                          <v-layout wrap justify-center>


                            <v-flex lg12 pb-1>
                              <span>Verification Report :</span> <br>
                              <v-btn small dark class="bgcustom"><a target="_blank"
                                  :href="mediaURL + list.verificationReport">

                                  <span style="
                          text-transform: none;
                          font-family: mainfont;
                          font-size: 12px;
                          color: white
                        ">View
                                  </span></a></v-btn>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex lg6>
                          <v-layout wrap justify-center>


                            <v-flex lg12 pb-3>
  <span>Photos :</span> <br>
  <v-layout row wrap>
    <v-flex
      v-for="(photo, index) in list.photos"
      :key="index"
      lg12
      class="pt-3 pl-3"
    >
      <v-btn small dark class="bgcustom">
        <a
          target="_blank"
          :href="mediaURL + photo"
          style="text-decoration: none"
        >
          <span
            style="
              text-transform: none;
              font-family: mainfont;
              font-size: 12px;
              color: white;
            "
          >
            View Photo {{ index + 1 }}
          </span>
        </a>
      </v-btn>
    </v-flex>
  </v-layout>
</v-flex>


                          </v-layout>
                        </v-flex>

                        <!-- <v-flex lg12 pb-1>
  <v-btn small dark  :href="mediaURL + list.userId.verificationReport" target="_blank"><span
                        style="
                          text-transform: none;
                          font-family: mainfont;
                          font-size: 12px;
                        ">View
                      </span></v-btn>
</v-flex> -->



                      </v-layout>

                    </v-flex>
                  </v-layout>


                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-start>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
                      <span style="font-size: 25px; color: white">Comments by RFO</span>
                    </v-flex>

                    <v-flex lg12 pa-4>
                      <v-container fluid>
                        <v-row>
                          <!-- <v-layout wrap justify-center>
            <v-flex lg12 v-for="(reason, index) in divisionRefusalReason" :key="index">
              <v-layout wrap justify-between align-center>
          
                <v-flex lg9>
                  <v-checkbox 
                    v-model="reason.isChecked" 
                    :label="reason.reason" 
                    color="primary" 
                    class="pa-0" 
                    hide-details="auto"
                    @change="updateSuggestions(index)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

    
              <v-flex lg12 v-if="reason.isChecked" pt-2>
          
                <v-text-field 
                  v-model="reason.suggestion" 
                  placeholder="Details of Offence" 
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-flex>
            </v-flex>
          </v-layout> -->

                          <!-- Detailed Remarks Section -->
                          <v-flex lg12>
                            <v-layout wrap justify-center>
                              <v-flex lg12 pb-1>
                                <span style="font-weight: 600">Detailed Remarks</span>
                              </v-flex>
                              <v-flex lg12>
                                <span>{{rangeRemarks}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                        </v-row>
                      </v-container>
                    </v-flex>

                  </v-layout>
                </v-card>

              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-start>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
                      <span style="font-size: 25px; color: white">Comments by DFO</span>
                    </v-flex>

                    <v-flex lg12 pa-4>
                      <v-container fluid>
                        <v-row>
                          <!-- <v-layout wrap justify-center>
            <v-flex lg12 v-for="(reason, index) in divisionRefusalReason" :key="index">
              <v-layout wrap justify-between align-center>
          
                <v-flex lg9>
                  <v-checkbox 
                    v-model="reason.isChecked" 
                    :label="reason.reason" 
                    color="primary" 
                    class="pa-0" 
                    hide-details="auto"
                    @change="updateSuggestions(index)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

    
              <v-flex lg12 v-if="reason.isChecked" pt-2>
          
                <v-text-field 
                  v-model="reason.suggestion" 
                  placeholder="Details of Offence" 
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-flex>
            </v-flex>
          </v-layout> -->

                          <!-- Detailed Remarks Section -->
                          <v-flex lg12>
                            <v-layout wrap justify-center>
                              <v-flex lg12 pb-1>
                                <span style="font-weight: 600">Detailed Remarks</span>
                              </v-flex>
                              <v-flex lg12>
                                <span>{{ divisionRemarks }}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                        </v-row>
                      </v-container>
                    </v-flex>

                  </v-layout>
                </v-card>

              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-start>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
                      <span style="font-size: 25px; color: white">Comments by Ministerial Head</span>
                    </v-flex>

                    <v-flex lg12 pa-4>
                      <v-container fluid>
                        <v-row>
                          <v-layout wrap justify-center>
                            <v-flex lg12 v-for="(reason, index) in ministirialRefusalReason" :key="index">
                              <v-layout wrap justify-between align-center>
                                <!-- Checkbox for the reason -->
                                <!-- <v-flex lg9>
                  <v-checkbox 
                    v-model="reason.isChecked" 
                    :label="reason.reason" 
                    color="black" 
                    class="pa-0" 
                    hide-details="auto"
                    readonly
                    @change="updateSuggestions(index)"
                  ></v-checkbox>
                </v-flex> -->

                                <v-flex lg9 pb-1 v-if="reason.isChecked">
                                  <span style="font-weight: 600">{{ reason.reason }}</span>
                                </v-flex>

                              </v-layout>

                              <!-- Conditionally render the text field for details if checkbox is checked -->
                              <v-flex lg12 pb-2 v-if="reason.isChecked">
                                <span style="color: #36454F;">{{ reason.suggestion }}</span>
                                <!-- <span>Ministirial Suggestion</span> -->
                                <!-- <v-text-field 
                  v-model="reason.suggestion" 
                  placeholder="Details of Offence" 
                  outlined
                  dense
                  readonly
                  hide-details="auto"
                ></v-text-field> -->
                              </v-flex>
                            </v-flex>
                          </v-layout>

                          <!-- Detailed Remarks Section -->
                          <v-flex lg12 pt-2>
                            <v-layout wrap justify-center>
                              <v-flex lg12 pb-1>
                                <span style="font-weight: 600">Detailed Remarks</span>
                              </v-flex>

                              <v-flex lg12>
                                <span style="color: #36454F	;">{{ ministerialRemarks }}</span>
                              </v-flex>
                            </v-layout>
                            <!-- <v-textarea 
              v-model="detailedRemarks" 
              outlined 
              dense 
              rows="2"
              readonly
              hide-details="auto"
            ></v-textarea> -->
                          </v-flex>
                        </v-row>
                      </v-container>
                    </v-flex>
                  </v-layout>

                </v-card>

              </v-flex>
            </v-layout>

            <v-layout wrap justify-center pt-4>
              <v-flex lg12>
                <v-card>
                  <v-layout wrap justify-start>
                    <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
                      <span style="font-size: 25px; color: white">Comments by Clerk</span>
                    </v-flex>

                    <v-flex lg12 pa-4>
                      <v-container fluid>
                        <v-row>
                          <!-- Loop through reasonsForRefusal array -->
                          <v-layout wrap justify-center>
                            <v-flex lg12 v-for="(reason, index) in clerkRefusalReason" :key="index">
                              <v-layout wrap justify-between align-center>
                                <!-- Checkbox for the reason -->
                                <!-- <v-flex lg9>
                      <v-checkbox 
                        v-model="reason.isChecked" 
                        :label="reason.reason" 
                        color="black" 
                        class="pa-0" 
                        readonly
                        hide-details="auto"
                      ></v-checkbox>
                    </v-flex> -->

                                <v-flex lg9 pb-1 v-if="reason.isChecked">
                                  <span style="font-weight: 600">{{ reason.reason }}</span>
                                </v-flex>

                              </v-layout>

                              <v-flex lg12 pb-2 v-if="reason.details !== ''">
                                <span style="color: #36454F;">{{ reason.details }}</span>
                                <!-- <v-text-field 
                      v-model="reason.details" 
                      placeholder="Details of Offence" 
                      outlined
                      dense
                      readonly 
                      hide-details="auto"
                    ></v-text-field> -->
                              </v-flex>

                            </v-flex>
                          </v-layout>

                          <v-flex lg12 pt-2>
                            <v-layout wrap justify-center>
                              <v-flex lg12 pb-1>
                                <span style="font-weight: 600">Detailed Remarks</span>
                              </v-flex>

                              <v-flex lg12>
                                <span style="color: #36454F	;">{{ clerkRemarks }}</span>
                              </v-flex>
                            </v-layout>
                            <!-- <v-textarea 
                    v-model="detailedRemarks" 
                    outlined 
                    dense 
                    readonly
                    rows="2"
                    hide-details="auto"
                  ></v-textarea> -->
                          </v-flex>

                        </v-row>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Delete Confirmation Dialog
      <v-dialog v-model="deleteDialogVisible" max-width="400px">
        <v-card>
          <v-card-title>Delete Reason</v-card-title>
          <v-card-text>Are you sure you want to delete this reason?</v-card-text>
          <v-card-actions>
            <v-btn color="red" text @click="deleteDialogVisible = false">Cancel</v-btn>
            <v-btn color="green" text @click="deleteReason">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
              </v-flex>
            </v-layout>
  
    
    </v-flex>
  </v-layout> 
  
  <v-layout wrap justify-center>
    <v-flex lg12>

    </v-flex>
  </v-layout>
          
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 pb-10>
          <v-layout wrap justify-center>
            <v-flex xs2>
              <v-btn color="primary" @click="goBack">
                <span style="text-transform: none; font-size: 15px; color: white">
                  GO BACK
                </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    


      <v-dialog
        :retain-focus="true"
        persistent
        v-model="deletedialog"
        max-width="600px"
      >
        <v-card>
          <v-card-title
            class="mainfont"
            style="color: black; font-size: 18px; font-weight: lighter"
            >Are you sure you want to Cancel?</v-card-title
          >
          <v-card-actions class="d-flex justify-center text-center">
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              text
              @click="deletedialog = false"
              class="mainfont"
              >Cancel</v-btn
            >
            <v-btn color="red" class="mainfont" text @click="deleteItem()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
     
      <v-dialog
        :retain-focus="true"
        persistent
        v-model="rejectdialog"
        max-width="600px"
      >
        <v-card>
          <v-layout wrap justify-start>
            <v-flex xs12>
              <v-card-title
                class="mainfont"
                style="color: black; font-size: 18px; font-weight: lighter"
              >
                Are you sure you want to Reject?
              </v-card-title>
            </v-flex>
            <v-flex xs12 pl-3 pr-3>
              <v-text-field
                type="text"
                dense
                color="#283e51"
                outlined
                background-color="white"
                v-model="reason"
                hide-details
              >
                <template v-slot:label>
                  <span
                    class="custom-label-text mainfont"
                    style="color: black; font-size: 14px"
                  >
                    Reason<span style="color: red; font-size: 20px">*</span>
                  </span>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              text
              @click="rejectdialog = false"
              class="mainfont"
              >Cancel</v-btn
            >
            <v-btn color="green" class="mainfont" text @click="rejectItem()"
              >Yes</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        :retain-focus="true"
        persistent
        v-model="forwarddialog"
        max-width="700px"
      >
        <v-card>
          <v-layout wrap justify-center>
            <v-flex xs8 text-left pt-5>
              <span
                class="mainfont"
                style="color: black; font-size: 18px; font-weight: lighter"
              >
                Are you sure you want to forward?
              </span>
            </v-flex>
            <v-flex xs8 pt-6 pr-4 class="mainfont">
  <v-autocomplete
    outlined
    dense
    color="black"
    :items="usernames"
    v-model="selectedUsername"
    item-text="name"
    item-value="name"
    placeholder="Select a Role"
    style="font-family: mainfont"
    hide-details
    clearable
    class="custom-autocomplete"
  >
    <template v-slot:append>
      <v-icon color="black">mdi-chevron-down</v-icon>
    </template>
  </v-autocomplete>
</v-flex>

<v-flex xs8 pt-5 pr-4 class="mainfont">
            <v-text-field placeholder="Reason" v-model="reason" dense class="mainfont" outlined color="black">
            </v-text-field>
          </v-flex>

          </v-layout>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              text
              @click="forwarddialog = false"
              class="mainfont"
              >Cancel</v-btn
            >
            <v-btn
              color="red"
              class="mainfont"
              text
              @click="forwardToUsers2()"
              :disabled="forwardInProgress"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        :retain-focus="true"
        persistent
        v-model="procceddialog"
        max-width="730px"
      >
        <v-card>
          <v-layout wrap justify-center>
            <v-flex xs8 text-left pt-5>
              <span
                class="mainfont"
                style="color: black; font-size: 18px; font-weight: lighter"
              >
                Are you sure you want to proceed this application for
                <br />
                1.&nbsp;Fee Payment
                <br />
                2.&nbsp;Agreement Execution
              </span>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              text
              @click="procceddialog = false"
              class="mainfont"
              >Cancel</v-btn
            >
            <v-btn color="red" class="mainfont" text @click="proceed()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
    
  <script>
  import axios from "axios";
  // import CryptoJS from "crypto-js";
  export default {
    components: {},
    data() {
      // const encryptedId = this.$route.query.id;
      // const decryptedId = CryptoJS.AES.decrypt(encryptedId, 'encryptionSecret').toString(CryptoJS.enc.Utf8);
      const today = new Date().toISOString().substr(0, 10);
      return {
        path: localStorage.getItem("path"),
        dialogVisible2: false,
        idNo: null,
        forwardInProgress: false,
        reason: null,
        procceddialog: false,
        startDate: today,
        showSnackBar: false,
        isChecked: false,
        deletedialog: false,
        forwarddialog: false,
        rejectdialog: false,
        openDialog: false,
        reportFile: null,
        file: null,
        mahasarFile: null,
        proceedingsFile: null,
        licenseFile: null,
        letterFile: null,
        appLoading: false,
        msg: "",
        id: this.$route.query.id,
        // id: decryptedId,
        name: null,
        dialogVisible: false,
        dialogVisibleproceedings: false,
        dialogVisiblelicense: false,
        dialogVisibleletter: false,
        barlist: [],
        range: [],
        list: {},
        divisionid: null,
        leaderdetails: [],
        idProof: "",
        Preshootfile: "",
        rangeid: null,
        filmShootingDetails: [],
        usernames: [],
        selectedUsername: "",
        selectedRanges: [],
        rangeRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],
      clerkRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],

      ministirialRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],

      divisionRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],
      isLoading: false,
      detailedRemarks: '',
      deleteDialogVisible: false,
      deleteIndex: null,
      forwardbtn: false,
      dfoSuggestions:[],
      refusalbtn: false,
      gpsReadings: "",
      inspectionReport: null,
      rfoPhotos: null,
      latitude: "",
      longitude: "",
      isSameImpression: false,
      distance:"",
      remarks: "",
      propertyMarkNumber:"",
      finalDecision:"",
      finalDecisionItems: ["Approved", "Approved after appeal", "Refuse"],
      clerkRemarks: "",
      ministerialRemarks: "",
      divisionRemarks: "",
      rangeRemarks: "",
    };
    },
    mounted() {
      this.getList();
      this.getRange();
    },
    created() {
      this.uType = localStorage.getItem("uType");
    },
  
    computed: {
      user() {
        const uType = localStorage.getItem("uType");
        if (uType === "777") {
          return "admin";
        } else if (uType === "772") {
          return "user";
        } else if (uType === "773") {
          return "range";
        } else if (uType === "7741") {
          return "section";
        } else if (uType === "7742") {
          return "superclerk";
        } else {
          return "division";
        }
      },
    },
  
    methods: {
    
     
    // addDFOSuggestion(index) {
    //   this.reasonsForRefusal[index].dfoSuggestions.push({ details: '' });
    // },
  

    // confirmDeleteReason(index) {
    //   this.deleteIndex = index;
    //   this.deleteDialogVisible = true;
    // },
  
    // deleteReason() {
    //   if (this.deleteIndex !== null) {
    //     this.reasonsForRefusal.splice(this.deleteIndex, 1);
    //     this.deleteDialogVisible = false;
    //     this.deleteIndex = null;
    //   }
    // },

    updateSuggestions(index) {
      // Reset suggestion field when checkbox is unchecked
      if (!this.ministirialRefusalReason[index].isChecked) {
        this.ministirialRefusalReason[index].suggestion = '';
      }
    },

    handleFileChange(field) {
      this[field] = this.$refs[field].files[0];
    },

    submitFinalDecision() {
    this.isLoading = true;
    axios({
      url: "/divsion/final/decision/approve",
      method: "POST",
      headers: { 
        token: localStorage.getItem("token"),
       },
      data:{
        appid: this.id,
        finalDecision: this.finalDecision,
        finalRemarks: this.remarks,
        propertyMarkRegistrationNumber: this.propertyMarkNumber,
      },
    })
    .then((response) => {
      if (response.data.status) {
        this.msg = response.data.msg;
        // this.forwardToUsers();
        this.$router.push({ path: "/ApplicationDivision" });
        this.forwarddialog = true;
      } else {
        this.msg = response.data.msg;
        this.showSnackBar = true;
      }
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
  submitFinalRefusal(){
    this.isLoading = true;
    axios({
      url: "/divsion/final/decision/refuse",
      method: "POST",
      headers: { 
        token: localStorage.getItem("token"),
       },
      data:{
        appid: this.id,
        finalDecision: this.finalDecision,
        finalRemarks: this.remarks,
        propertyMarkRegistrationNumber: this.propertyMarkNumber,
      },
    })
    .then((response) => {
      if (response.data.status) {
        this.msg = response.data.msg;
        // this.forwardToUsers();
        this.$router.push({ path: "/ApplicationDivision" });
        this.
        this.forwarddialog = true;
      } else {
        this.msg = response.data.msg;
        this.showSnackBar = true;
      }
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
  
  
  
  
      settoforward() {
        this.curIdToDelete = this.id;
      },
      proceed() {
        const idToDelete = this.curIdToDelete;
        if (!idToDelete) {
          return;
        }
        axios({
          url: "/division/payment/initiation/",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            reason: this.reason,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.deletedialog = false;
              window.location.reload();
              this.$router.push({ path: "/ApplicationDivision" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      forwardToUsersone(id) {
        this.getUsersone(id);
        this.appids = id;
      },
      forwardToUsers(id) {
        this.getUsers(id);
        this.appids = id;
      },
      // forwardToUsers2() {
      //   this.forward();
      // },
      forwardToUsers2() {
       // Set flag to indicate forwarding is in progress
        this.forward();
      },
      getUsers() {
        // this.isLoading = true;
        this.forwarddialog = true;
        axios({
          method: "GET",
          url: "/ministerialhead/forward/list",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
          },
        })
        .then((response) => {
      // Log the full response for inspection
      console.log("Full Response:", response);
  
      // Access the data array within the response object
      const usersArray = response.data.data;
  
      // Check if usersArray is indeed an array
      if (Array.isArray(usersArray)) {
        this.usernames = usersArray.map(user => {
          console.log("User:", user); // Log each user object for clarity
          return {
            name: `${user.officeName}`, // Adjust role based on your logic
            role: "SFO", // Static role for now, can be dynamic
            userId: user._id,
          };
        });
      } else {
        console.error("Expected an array but got something else:", usersArray);
      }
      this.isLoading = false;
      // Log the final usernames array
      console.log("Usernames Array:", this.usernames);
    })
    .catch((err) => {
      this.ServerError = true;
      console.error("Error:", err);
    });
  },
      getUsersone() {
        axios({
          method: "post",
          url: "/dfo/forward/list",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
          },
        })
          .then((response) => {
            this.usernames = [
              // { name: `${response.data.user.username} (User)`, role: "User", userId: response.data.user._id },
              {
                name: `${response.data.superintendent.username} (Superintendent)`,
                role: "Superintendent",
                userId: response.data.superintendent._id,
              },
            ];
          })
          .catch((err) => {
            this.ServerError = true;
            console.log(err);
          });
      },
      forward() {
       
        if (!this.selectedUsername) {
          // this.$refs.snackbar.showSnackbar("Please select a user to forward to.");
          this.msg = "Please select a user to forward to.";
          this.showSnackBar = true;
          this.forwardInProgress = false;
          return;
        }
        console.log("Bhoommmmm111111111");
        const selectedUser = this.usernames.find(
          (user) => user.name === this.selectedUsername
        );
        
        console.log("Bhoommmmm333333333");
        axios({
          method: "post",
          url: "application/forward",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            forwardto: selectedUser.userId,
            reason: this.reason,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              alert(response.data.msg);
              this.msg = response.data.msg;
              this.showSnackBar = true;
              // window.location.reload();
              this.$router.push({ path: "/superintedent" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.error(err);
          });
      },

      forwardTo() {
        axios({
          method: "post",
          url: "application/forward",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            forwardto: this.selectedUsername,
            reason: this.detailedRemarks,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              alert(response.data.msg);
              this.msg = response.data.msg;
              this.showSnackBar = true;
            //   window.location.reload();
              this.$router.push({ path: "/RangeApplicationSections" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.error(err);
          });
      },
    //   forwardToClerk() {
    // this.isLoading = true;
    
    // // Create a FormData object to handle file uploads
    // const formData = new FormData();
    // formData.append("appid", this.id);
    // formData.append("verificationReport", this.verificationReport);
    // formData.append("photos", this.photos);
    // formData.append("detailedRemarks", this.detailedRemarks);

    // axios({
    //   url: "/rfoadd/reports/photos",
    //   method: "POST",
    //   headers: { 
    //     token: localStorage.getItem("token"),
    //     "Content-Type": "multipart/form-data" // Ensure this header is set for file uploads
    //   },
    //   data: formData, // Pass the FormData object
    // })
    // .then((response) => {
    //   if (response.data.status) {
    //     this.msg = response.data.msg;
    //     this.forwardToUsers();
    //     this.forwarddialog = true;
    //   } else {
    //     this.msg = response.data.msg;
    //     this.showSnackBar = true;
    //   }
    // })
    // .catch((err) => {
    //   console.error(err);
    // })
    // .finally(() => {
    //   this.isLoading = false;
    // });
    //   },
      // forwardToRange() {
  
      //   axios({
      //     url: "/range/forward/",
      //     method: "POST",
      //     headers: {
      //       token: localStorage.getItem("token"),
      //     },
      //     data: {
      //       appid: this.id,
      //       rangeid: this.rangeid,
      //     },
      //   })
      //     .then((response) => {
      //       this.appLoading = false;
      //       if (response.data.status == true) {
      //         this.msg = response.data.msg;
      //         this.showSnackBar = true;
      //         this.deletedialog = false;
      //         this.$router.push({ path: "/ApplicationDivision" });
      //         window.location.reload();
      //       } else {
      //         this.msg = response.data.msg;
      //         this.showSnackBar = true;
      //       }
      //     })
      //     .catch((err) => {
      //       this.appLoading = false;
      //       this.ServerError = true;
      //       console.log(err);
      //     });
      // },
  
      forwardToRange() {
        axios({
          url: "/range/forward/",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            rangeid: this.selectedRanges,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
              window.alert(response.data.msg);
              // this.msg = response.data.msg;
              this.$router.push({
                path: "/ApplicationDivision",
              });
              window.location.reload();
              this.showSnackBar = true;
              this.deletedialog = false;
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
  
      getRange() {
        this.appLoading = true;
  
        axios({
          method: "post",
          url: "/get/range",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            divisionid: this.divisionid,
            path: this.path,
          },
        })
          .then((response) => {
            this.range = response.data.data;
            this.appLoading = false;
          })
          .catch((err) => {
            this.ServerError = true;
            console.log(err);
          });
      },
      goBack() {
        // Use the router to navigate back to the previous page
        this.$router.go(-1);
      },
      forwardToClerk2() {
        axios({
          url: "/range/forward/clerk",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.deletedialog = false;
              // window.location.reload();
              this.$router.push({ path: "/rangebookings" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      formatDate(item) {
        var dt = new Date(item);
        var year = dt.getFullYear();
        dt = dt.toString();
        var strTime = dt.slice(4, 10) + " " + year;
        return strTime;
      },
      
  
      uploadReport() {
        const formData = new FormData();
        formData.append("rangeReport", this.reportFile);
        formData.append("appid", this.id);
        axios
          .post(`/report/upload`, formData, {
            headers: {
              token: localStorage.getItem("token"),
            },
            data: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response.data);
            (this.dialogVisible = false), location.reload();
          })
          .catch((error) => {
            // Handle error
            console.error(error);
          });
      },
     
     
      
      openFileInput() {
        this.$refs.fileInput.click();
      },
      handleFileUpload(event) {
        const selectedFile = event.target.files[0];
        console.log("Selected file:", selectedFile);
      },
      // forwardToClerk() {
      //   axios({
      //     url: "/check/forward",
      //     method: "POST",
      //     headers: {
      //       token: localStorage.getItem("token"),
      //     },
      //     data: {
      //       appid: this.id,
      //     },
      //   })
      //     .then((response) => {
      //       this.appLoading = false;
      //       if (response.data.status == true) {
      //         this.msg = response.data.msg;
      //         this.showSnackBar = true;
      //         window.location.reload();
      //       } else {
      //         this.msg = response.data.msg;
      //         this.showSnackBar = true;
      //       }
      //     })
      //     .catch((err) => {
      //       this.appLoading = false;
      //       this.ServerError = true;
      //       console.log(err);
      //     });
      // },
      submitfee() {
        axios({
          url: "/addSecurityDepositAndShootingFee",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            securitydeposit: this.list.securitydeposit,
            shootingfee: this.list.shootingfee,
            refundAmount: this.list.refundAmount,
          },
        })
          .then((response) => {
            this.appLoading = false;
            this.msg = response.data.msg;
            if (response.data.status == true) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              window.location.reload();
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      
      deleteItem() {
        axios({
          url: "/cancel/application",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.deletedialog = false;
              window.location.reload();
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      rejectItem() {
        axios({
          method: "POST",
          url: "/division/approval",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            status: "no",
            reason: this.reason,
            appid: this.id,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.showSnackBar = true;
  
              this.msg = response.data.msg;
              this.rejectdialog = false;
              this.$router.push({ path: "/ApplicationDivision" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.rejectdialog = false;
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.error(err);
          });
      },
  
      Refusal(){
        axios({
          method: "POST",
          url: "/divsion/final/decision/refuse",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            appid: this.id,
            detailedRemarks: this.detailedRemarks,   
            finalDecision: 'yes'
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.showSnackBar = true;
  
              this.msg = response.data.msg;
              this.$router.push({ path: "/ApplicationDivision" });
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.rejectdialog = false;
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.error(err);
          });
      },
  
      getAcknowledgment() {
        const token = localStorage.getItem("token");
        const downloadUrl = "/acknowledgement/pdf";
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            appid: this.id,
          },
          responseType: "blob",
        };
  
        axios
          .get(downloadUrl, config)
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
  
            // Open the URL in a new tab
            const newTab = window.open();
            newTab.document.write(
              '<iframe width="100%" height="100%" src="' +
                url +
                '" type="application/pdf"></iframe>'
            );
            newTab.document.close();
          })
          .catch((error) => {
            console.error("Error downloading acknowledgement:", error);
          });
      },
      
      
  
      getApplication() {
        const token = localStorage.getItem("token");
        const downloadUrl = "/application/pdf";
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            appid: this.id,
          },
          responseType: "blob",
        };
  
        axios
          .get(downloadUrl, config)
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
  
            // Open the URL in a new tab
            const newTab = window.open();
            newTab.document.write(
              '<iframe width="100%" height="100%" src="' +
                url +
                '" type="application/pdf"></iframe>'
            );
            newTab.document.close();
          })
          .catch((error) => {
            console.error("Error downloading acknowledgement:", error);
          });
      },
  
      
  
      getList() {
    this.appLoading = true;
    axios({
      method: "POST",
      url: "/single/application",
      headers: {
        token: localStorage.getItem("token"),
      },
      data: {
        appid: this.id,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          // Extract data from the response
          this.list = response.data.data;
          this.filmShootingDetails = this.list.filmShootingDetails;
          this.memberDetails = this.list.memberDetails;
          this.idProof = this.list.idProof;
          this.Preshootfile = this.list.Preshootfile;
          this.reqLetter = this.list.reqLetter;
          this.participantfile = this.list.participantfile;
          this.leaderIdProof = this.list.leaderIdProof;
          this.rangeMahassars = this.list.rangeMahassars;
          this.rangeReports = this.list.rangeReports;
  
          // Retrieve reasons for refusal from backend
          const backendReasons = this.list.reasonsForRefusal || [];
            const backendSuggestions = this.list.ministerialSuggestions || [];
            const backenddfoSuggestions = this.list.dfoSuggestions || [];

            // Assign backend values to clerkRefusalReason based on matching reason text
            this.clerkRefusalReason = this.clerkRefusalReason.map((localReason) => {
              const foundReason = backendReasons.find(item => item.reason === localReason.reason);
              return {
                ...localReason,
                isChecked: !!foundReason,
                details: foundReason ? foundReason.details : '',
              };
            });

            // Assign backend values to ministerialRefusalReason based on matching suggestion text
            this.ministirialRefusalReason = this.ministirialRefusalReason.map((localReason) => {
              const foundSuggestion = backendSuggestions.find(item => item.suggestion === localReason.reason);
              return {
                ...localReason,
                isChecked: !!foundSuggestion,
                suggestion: foundSuggestion ? foundSuggestion.details : '',
              };
            });

            // Assign backend values to divisionRefusalReason based on matching suggestion text
            this.divisionRefusalReason = this.divisionRefusalReason.map((localReason) => {
              const foundSuggestion = backenddfoSuggestions.find(item => item.suggestion === localReason.reason);
              return {
                ...localReason,
                isChecked: !!foundSuggestion,
                suggestion: foundSuggestion ? foundSuggestion.details : '',
              };
            });
  
            this.clerkRemarks = this.list.clerkRemarks;
            this.ministerialRemarks = this.list.ministerialRemarks;
            this.divisionRemarks = this.list.divisionRemarks;
            this.rangeRemarks = this.list.rangeRemarks;

          this.appLoading = false;
        } else {
          // Handle the case where the status is false
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.appLoading = false;
        }
      })
      .catch((err) => {
        this.ServerError = true;
        console.error(err);
      });
  },
  
  
  
  
    },
  };
  </script>
    
    
  <style>
  .subheading {
    font-family: mainfont;
    color: #42275a;
    text-transform: none;
    font-size: 17px;
    font-weight: bold;
  }
  
  .heading {
    font-family: mainfont;
    color: white;
    text-transform: none;
    font-size: 22px;
  }
  .inputPrice input::-webkit-outer-spin-button,
  .inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  </style>